module.exports = __webpack_public_path__ + "static/greg-6a75955082b794c4e43db0e90cb27d65.jpeg";